<template>
    <div
        class="compose-feedback"
        v-if="!$authUser.isStudent()">
        <div class="component-title">
            <h5 class="title">{{ $t('assignment.add_feedback') }}</h5>
        </div>

        <b-alert
            v-if="hasError"
            variant="danger"
            show>
            Je hebt nog geen feedback opgegeven.
        </b-alert>

        <ckeditor
            v-model="text"
            @ready="onReady"
            :editor="editor"
            :config="editorConfig"
            :placeholder="$t('assignment.enter_feedback')">
        </ckeditor>

        <b-button
            class="btn-save btn-add-feedback"
            v-if="showStoreButton"
            variant="primary"
            @click="storeFeedback"
            :disabled="text === ''">
            {{ $t('common.save') }}
        </b-button>
    </div>
</template>

<script>
import ApprenticeEditor from '../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-assignment-show-compose-assignment-feedback-component',
    props: {
        assignmentIn: Object,
        projectId: Number,
        showStoreButton: {
            type: Boolean,
            required: false,
            default: true,
        },
    },

    data() {
        return {
            text: '',
            editor: ApprenticeEditor,
            editorConfig: {
                contentsCss: 'test',
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'heading',
                        'fontBackgroundColor',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'insertTable',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        'undo',
                        'redo',
                    ],
                },
                language: this.$authUser.locale,
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells'],
                },
            },
            hasError: false,
        };
    },
    methods: {
        storeFeedback() {
            this.hasError = false;

            if (!this.text && (!this.assignmentIn.feedback || !this.assignmentIn.feedback.text)) {
                this.hasError = true;
                return;
            }

            const data = {
                assignment_id: this.assignmentIn.id,
                text: this.text,
                project_id: this.projectId,
            };

            this.alert.saving();
            this.axios.post(this.routes.assignmentFeedback(), data).then(
                (response) => {
                    this.assignmentIn.addRelation('feedback', response.data);
                    this.text = '';
                    this.alert.success();
                    this.$emit('store-completed');
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        onReady() {
            const wrapper = document.querySelector('.ck-body-wrapper');
            wrapper.remove();
            const editor = document.querySelector('.ck-editor');
            editor.appendChild(wrapper);
        },
    },
};
</script>

<style scoped lang="scss">
.btn-add-feedback {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');
}

.compose-feedback {
    &[aria-disabled='true'] {
        pointer-events: none;
    }
}
</style>
